(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-scandinavian"] && !Shopify.designMode) return;
  try {
    
class HeroImageSlideshow extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.hero-scandi__slide'));
    this.current = 0;
    this.auto  = this.dataset.auto === 'true';
    this.speed = parseInt(this.dataset.speed, 10) || 4000;

    if (this.auto && this.slides.length > 1) {
      this.timer = setInterval(() => this.goTo((this.current + 1) % this.slides.length), this.speed);
      this.addEventListener('mouseenter', () => clearInterval(this.timer));
      this.addEventListener('mouseleave', () => {
        this.timer = setInterval(() => this.goTo((this.current + 1) % this.slides.length), this.speed);
      });
    }
  }

  cardForIndex(index) {
    return this.querySelector(`.hero-scandi__slide-card[data-slide="${index}"]`);
  }

  goTo(index) {
    if (index === this.current) return;
    this.slides[this.current].classList.remove('is-active');
    const prevCard = this.cardForIndex(this.current);
    if (prevCard) prevCard.classList.remove('is-active');

    this.current = index;
    this.slides[this.current].classList.add('is-active');
    const nextCard = this.cardForIndex(this.current);
    if (nextCard) nextCard.classList.add('is-active');
  }
}
customElements.define('hero-image-slideshow', HeroImageSlideshow);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
class HeroSlider extends HTMLElement {
  connectedCallback() {
    this.track  = this.querySelector('.hero-slider__track');
    this.slides = Array.from(this.querySelectorAll('.hero-slider__slide'));
    this.dots   = Array.from(this.querySelectorAll('.hero-slider__dot'));
    this.current = 0;
    this.auto  = this.dataset.auto === 'true';
    this.speed = parseInt(this.dataset.speed, 10) || 5000;

    this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.goTo(i)));
    this.slides.forEach((slide, i) => {
      slide.addEventListener('click', () => { if (i !== this.current) this.goTo(i); });
    });

    this._onResize = () => this._position();
    window.addEventListener('resize', this._onResize);
    this._position();

    if (this.auto && this.slides.length > 1) this._startTimer();
    this.addEventListener('mouseenter', () => this._stopTimer());
    this.addEventListener('mouseleave', () => { if (this.auto) this._startTimer(); });

    let sx = 0;
    this.addEventListener('touchstart', e => { sx = e.touches[0].clientX; }, { passive: true });
    this.addEventListener('touchend', e => {
      const dx = sx - e.changedTouches[0].clientX;
      if (Math.abs(dx) > 40) this.goTo(
        dx > 0
          ? Math.min(this.current + 1, this.slides.length - 1)
          : Math.max(this.current - 1, 0)
      );
    });
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this._onResize);
    this._stopTimer();
  }

  _position() {
    const slideW = this.slides[0]?.offsetWidth || 0;
    const gap    = parseFloat(getComputedStyle(this.track).gap) || 20;
    const peek   = (this.offsetWidth - slideW) / 2;
    this.track.style.transform = `translateX(${peek - this.current * (slideW + gap)}px)`;
  }

  goTo(index) {
    if (index === this.current) return;
    this.slides[this.current].classList.remove('is-active');
    this.dots[this.current]?.classList.remove('is-active');
    this.dots[this.current]?.setAttribute('aria-selected', 'false');
    this.current = index;
    this.slides[this.current].classList.add('is-active');
    this.dots[this.current]?.classList.add('is-active');
    this.dots[this.current]?.setAttribute('aria-selected', 'true');
    this._position();
  }

  _startTimer() {
    this._stopTimer();
    this.timer = setInterval(() => this.goTo((this.current + 1) % this.slides.length), this.speed);
  }
  _stopTimer() { clearInterval(this.timer); }
}
customElements.define('hero-slider', HeroSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
